'use client';

import { styled } from '@mui/system';

type Size = 'big' | 'small';

interface Props {
  source?: string;
  size?: Size;
}

const SIZE: { [K in Size]: string } = {
  big: '60%',
  small: '40%',
};

const LogoImage = styled('img', { shouldForwardProp: (prop) => prop !== 'size' })<Props>(({ theme, size = 'big' }) => ({
  display: 'inline-block',
  maxWidth: theme.spacing(20),
  width: SIZE[size],
}));

export const Logo = ({ source = '/images/logo.svg', size = 'big' }: Props) => {
  return <LogoImage src={source} alt="Company Logo" size={size} />;
};
